import request from './request';

import { ENDPOINT } from '../../constants/api';

export default {
  getListingsByLinkId({ linkId, shopId, db, signal }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V3,
      params: { db },
      signal,
      url: `/product-links/shops/${shopId}/link/${linkId}`,
    });
  },
  getListingsByTitleOrSKU({ query, shopId, db, signal }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V3,
      params: { db, title_or_sku: query },
      signal,
      url: `/product-links/shops/${shopId}/search`,
    });
  },
  createProductLink({
    signal,
    linkId,
    sourceShopId,
    sourceProductId,
    sourceChannelId,
    sourceDb,
    productLinks,
  }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V3,
      params: { db: sourceDb },
      payload: {
        link_id: linkId,
        source_shop_id: sourceShopId,
        source_product_id: sourceProductId,
        source_channel_id: sourceChannelId,
        source_db: sourceDb,
        product_links: productLinks,
      },
      signal,
      url: `/product-links/shops/${sourceShopId}/link`,
    });
  },
  getSuggestedListings({ shopId, listingId, db, signal }) {
    return request.get({
      endpoint: ENDPOINT.IMAGE_GROUPING,
      params: { db },
      signal,
      url: `/shops/${shopId}/matching-listings-by-primary-image/${listingId}`,
    });
  },
  deleteLinkForListing({ shopId, linkId, detailIds, signal, db }) {
    return request.delete({
      endpoint: ENDPOINT.WEB_V3,
      params: { db },
      payload: {
        product_link_detail_ids: detailIds,
      },
      signal,
      url: `/product-links/shops/${shopId}/link/${linkId}`,
    });
  },
};
